import "./chatbox.css";
import Cookies from "js-cookie";
import DeleteModal from "../DeleteModal";
import { Bounce, toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { IoArrowDownSharp } from "react-icons/io5";
import chatbackground from "src/assets/chatbackground.png";
import React, { useContext, useEffect, useRef, useState } from "react";
import SendMessageTemplate from "src/components/atoms/SendMessageTemplate";
import RecivedMessageTemplate from "src/components/atoms/RecivedMessageTemplate";
import { AdminDashboardContext, MyContext } from "src/components/Context/MyContext";

const ChatBox = ({ setReplyMessage, loadOlderChat, totalConversationHistory, loadMsgLoading, setLoadMsgLoading, showLoadmoreBtn }) => {
  const roleId = Cookies.get("roleId");
  const authorName = Cookies.get("name");
  const { socket,userId } = useContext(MyContext);
  const { selectedChat } = useContext(MyContext);
  const { messages, setMessages } = useContext(AdminDashboardContext);
  const [openReply, setOpenReply] = useState(null);
  const [isAtBottom, setIsAtBottom] = useState(true);
  const [openDelete, setOpenDelete] = useState(false);
  const [openModalId, setOpenModalId] = useState(null);
  const [activeAudio, setActiveAudio] = useState(null);
  const [hoveredMessageId, setHoveredMessageId] = useState(null);
  const [loadMoreMsgLoading, setLoadMoreMsgLoading] = useState(false);

  const scrollRef = useRef(null);
  const chatEndRef = useRef(null);
  const pageNumbers = useRef(1);
  const messageRefs = useRef({});

  useEffect(() => {
    pageNumbers.current = 1;
  }, [selectedChat]);

  useEffect(() => {
    if (loadMoreMsgLoading) {
      setLoadMoreMsgLoading(false);
      return;
    }
    chatEndRef.current?.scrollIntoView({ behavior: "auto" });
    const timeout = setTimeout(() => {
      chatEndRef.current?.scrollIntoView({ behavior: "auto" });
    }, 1000); // adjust timing if needed
    return () => clearTimeout(timeout);
  }, [messages]);

  // useEffect(() => {
  //   if (isAtBottom) {
  //     messages?.length <= 50 && chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  //     scrollRef?.current?.classList.add("fadeScroll");
  //     const timeoutId = setTimeout(() => {
  //       scrollRef.current?.classList.remove("fadeScroll");
  //     }, 1000);
  //     return () => clearTimeout(timeoutId);
  //   }
  // }, [messages]);

  // new change for open reply issue at bottom
  useEffect(() => {
    if (openReply && isAtBottom) {
      chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [openReply, isAtBottom]);

  const handleClick = (id) => {
    setOpenModalId((prevId) => (prevId === id ? null : id));
    setOpenReply(null);
  };

  const handleOpenModal = (id) => {
    setOpenModalId(id);
    setOpenDelete(true);
  };

  const handleOpenReply = (id) => {
    setOpenReply((prevId) => (prevId === id ? null : id));
  };

  const handleHoverMessage = (id) => {
    if (hoveredMessageId !== id && openReply !== null) {
      setOpenReply(null);
    }
    setHoveredMessageId(id);
  };

  const scrollToBottom = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: scrollRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      setIsAtBottom(scrollTop + clientHeight >= scrollHeight - 10);
    }
  };

  useEffect(() => {
    const chatBox = scrollRef.current;
    if (chatBox) {
      chatBox.addEventListener("scroll", handleScroll);
      return () => chatBox.removeEventListener("scroll", handleScroll);
    }
  }, []);

  //use for delete the particular message from sender side only
  const messageDeleted = (msgId) => {
    const filterData = messages.filter((msg) => msg._id === openModalId);
    const showChat = JSON.parse(localStorage.getItem("showChat"));
    const option = {
      messageId: [filterData[0].messageId],
      userId: userId,
      participantId: [String(showChat?.user_id)],
      errollmentId: String(showChat?._id),
    };
    socket.emit("delete-message", option);
    setMessages((prevMessages) => prevMessages.map((msg) => (msg._id === openModalId ? { ...msg, isDeleted: true } : msg)));
    setOpenDelete(false);
  };

  let sortArray = messages?.slice().sort((a, b) => a.messageTime.localeCompare(b.messageTime));

  // ************* For Copy Text ****************
  const handleCopy = (message) => {
    if (message?.type !== "text") {
      toast.error("Copy not allowed for this message", {
        position: "top-center",
        autoClose: 500,
        transition: Bounce,
      });
      return;
    }
    navigator.clipboard
      .writeText(message.content)
      .then(() =>
        toast.success("Text copied!", {
          position: "top-center",
          autoClose: 50,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        })
      )
      .catch(() =>
        toast.error("Failed to copy", {
          position: "top-center",
          autoClose: 50,
          transition: Bounce,
        })
      );
  };

  const closeModal = () => {
    setOpenDelete(false);
    setHoveredMessageId(null);
    setOpenModalId(null);
  };

  const [highlightedMessageId, setHighlightedMessageId] = useState(null);

  const scrollToMessage = (messageId) => {
    const messageElement = messageRefs.current[messageId];
    if (messageElement) {
      messageElement.scrollIntoView({ behavior: "smooth", block: "center" });

      // Highlight the message briefly
      setHighlightedMessageId(messageId);
      setTimeout(() => setHighlightedMessageId(null), 2000);
    }
  };

  return (
    <div ref={scrollRef} className="w-full h-[99%] bg-contain mt-1 border-t border-b overflow-y-auto  relative" style={{ backgroundImage: `url(${chatbackground})` }}>
      {!isAtBottom && (
        <div className="fixed bottom-[25%] md:bottom-[22%] right-5 z-10 bg-white border text-black rounded shadow p-2 cursor-pointer" onClick={scrollToBottom}>
          <IoArrowDownSharp size={20} />
        </div>
      )}
      <div className="flex flex-col space-y-1 p-4 custom-scrollbar">
        {messages.length > 0 ? (
          totalConversationHistory.current > messages.length && showLoadmoreBtn ? (
            <div className="flex items-center justify-center">
              {loadMsgLoading ? (
                <CircularProgress className="flex items-center justify-center p-2 " sx={{ color: "#FBF712" }} />
              ) : (
                <button
                  className="flex items-center justify-center p-2 bg-white rounded-md w-[20%] hover:bg-[#FBF712] "
                  onClick={() => {
                    setLoadMsgLoading(true);
                    loadOlderChat(pageNumbers.current + 1);
                    setLoadMoreMsgLoading(true);
                    pageNumbers.current = pageNumbers.current + 1;
                  }}
                >
                  Click here to get older message
                </button>
              )}
            </div>
          ) : null
        ) : null}
        {messages
          ?.slice()
          .sort((a, b) => a.messageTime.localeCompare(b.messageTime))
          .map((message, index) => {
            return (
              <div key={message._id} ref={(el) => (messageRefs.current[message._id] = el)} className={`message-item ${highlightedMessageId === message._id ? "bg-[#FFFFD9]" : ""}`}>
                {index == 0 ? (
                  <div className=" w-full flex justify-center items-center my-2">
                    <p className=" bg-white p-2 rounded-lg font-medium text-sm">{message.DateFormated}</p>
                  </div>
                ) : message.DateFormated.toString() !== sortArray[index - 1].DateFormated.toString() ? (
                  <div className=" w-full flex justify-center items-center my-2">
                    <p className=" bg-white p-2 rounded-lg font-medium text-sm">{message.DateFormated}</p>
                  </div>
                ) : null}
                {String(message.author) === roleId ? (
                  <div className="flex justify-end">
                    <SendMessageTemplate
                      data={message}
                      setActiveAudio={setActiveAudio}
                      activeAudio={activeAudio}
                      isModalOpen={openModalId === message._id}
                      handleOpen={() => handleOpenReply(message._id)}
                      handleClick={() => handleClick(message._id)}
                      openReply={openReply === message._id}
                      handleOpenModal={() => handleOpenModal(message._id)}
                      isHovered={hoveredMessageId === message._id}
                      onMouseEnter={() => handleHoverMessage(message._id)}
                      onMouseLeave={() => setHoveredMessageId(null)}
                      handleMessageReply={() => {
                        setReplyMessage(message);
                        setOpenReply(message._id);
                      }}
                      handleCopy={() => handleCopy(message)}
                      scrollToMessage={scrollToMessage}
                    />
                  </div>
                ) : ((String(message.author) !== String(userId)) || authorName === "ImWow Super Admin") ? (
                  <div className="flex justify-start">
                    <RecivedMessageTemplate
                      data={message}
                      setActiveAudio={setActiveAudio}
                      activeAudio={activeAudio}
                      isModalOpen={openModalId === message._id}
                      handleClick={() => handleClick(message._id)}
                      handleOpen={() => handleOpenReply(message._id)}
                      openReply={openReply === message._id}
                      handleOpenModal={() => handleOpenModal(message._id)}
                      isHovered={hoveredMessageId === message._id}
                      onMouseEnter={() => handleHoverMessage(message._id)}
                      onMouseLeave={() => setHoveredMessageId(null)}
                      handleMessageReply={() => {
                        setReplyMessage(message);
                        setOpenReply(message._id);
                      }}
                      handleCopy={() => handleCopy(message)}
                      scrollToMessage={scrollToMessage}
                    />
                  </div>
                ) : (
                  <div className="flex justify-end">
                    <SendMessageTemplate
                      data={message}
                      setActiveAudio={setActiveAudio}
                      activeAudio={activeAudio}
                      isModalOpen={openModalId === message._id}
                      handleOpen={() => handleOpenReply(message._id)}
                      handleClick={() => handleClick(message._id)}
                      openReply={openReply === message._id}
                      handleOpenModal={() => handleOpenModal(message._id)}
                      isHovered={hoveredMessageId === message._id}
                      onMouseEnter={() => handleHoverMessage(message._id)}
                      onMouseLeave={() => setHoveredMessageId(null)}
                      handleMessageReply={() => {
                        setReplyMessage(message);
                        setOpenReply(message._id);
                      }}
                      handleCopy={() => handleCopy(message)}
                      scrollToMessage={scrollToMessage}
                    />
                  </div>
                )}
              </div>
            );
          })}
      </div>
      <div ref={chatEndRef} />

      {openDelete && <DeleteModal open={openDelete} close={() => closeModal()} deleteMsg={() => messageDeleted()} />}
    </div>
  );
};

export default ChatBox;
